import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";


import './App.css';
import Login from './screens/loginScreen';
import Signup from './screens/signUpScreen';
import Dashboard from './screens/Dashboard';
import CRMScreen from './screens/CRMScreen';
import VendorScreen from './screens/vendorScreen';
import ProductScreen from './screens/productScreen';
import PurchasesScreen from './screens/PurchasesScreen';
import WarehouseScreen from './screens/WarehouseScreen';
import SalesOrdersScreen from './screens/Sales&OrdersScreen';
import InvoicesScreen from './screens/InvoicesScreen';
import PaymentsScreen from './screens/PaymentsScreen';
import ExpensesScreen from './screens/ExpensesScreen';
import ReportScreen from './screens/ReportsScreen';
import UserRolesScreen from './screens/UserRolesScreen';
import TeamPerformanceScreen from './screens/TeamPerformanceScreen';
import MarketingScreen from './screens/MarketingScreen';
import AddVendorScreen from './screens/AddVendorScreen';
import AddProductScreen from "./screens/AddProduct";
import CreatePurchase from "./screens/CreatePurchase";
import CreateSales from "./screens/CreateSales";
import CreateInvoice from "./screens/CreateInvoice";
import EditInvoice from "./screens/EditInvoice";
import RecordPayment from "./screens/RecordPayment";
import AddExpensesScreen from "./screens/AddExpenses";
import AddUser from "./screens/AddUser";
import AddCustomer from "./screens/AddCustomer";
import VATScreen from "./screens/VATScreen";
import IntegrationsScreen from "./screens/IntegrationsScreen";


import ProtectedRoute from "./components/ProtectedRoute";
import { ToastProvider } from "./context/ToastContext";
import "./components/Toast.css";

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <MainLayout>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/crm" element={<ProtectedRoute><CRMScreen /></ProtectedRoute>} />
            <Route path="/customers/add" element={<ProtectedRoute><AddCustomer /></ProtectedRoute>} />
            <Route path="/customers/edit/:id" element={<ProtectedRoute><AddCustomer /></ProtectedRoute>} />
            <Route path="/vendors" element={<ProtectedRoute><VendorScreen /></ProtectedRoute>} />
            <Route path="/vendors/add" element={<ProtectedRoute><AddVendorScreen /></ProtectedRoute>} />
            <Route path="/vendors/edit/:id" element={<ProtectedRoute><AddVendorScreen /></ProtectedRoute>} />
            <Route path="/products" element={<ProtectedRoute><ProductScreen /></ProtectedRoute>} />
            <Route path="/products/add" element={<ProtectedRoute><AddProductScreen /></ProtectedRoute>} />
            <Route path="/products/edit/:id" element={<ProtectedRoute><AddProductScreen /></ProtectedRoute>} />
            <Route path="/purchases" element={<ProtectedRoute><PurchasesScreen /></ProtectedRoute>} />
            <Route path="/purchases/create" element={<ProtectedRoute><CreatePurchase /></ProtectedRoute>} />
            <Route path="/purchases/edit/:id" element={<ProtectedRoute><CreatePurchase /></ProtectedRoute>} />
            <Route path="/warehouse" element={<ProtectedRoute><WarehouseScreen /></ProtectedRoute>} />
            <Route path="/sales-orders" element={<ProtectedRoute><SalesOrdersScreen /></ProtectedRoute>} />
            <Route path="/sales/create" element={<ProtectedRoute><CreateSales /></ProtectedRoute>} />
            <Route path="/sales/edit/:id" element={<ProtectedRoute><CreateSales /></ProtectedRoute>} />
            <Route path="/invoices" element={<ProtectedRoute><InvoicesScreen /></ProtectedRoute>} />
            <Route path="/invoices/create" element={<ProtectedRoute><CreateInvoice /></ProtectedRoute>} />
            <Route path="/invoices/edit/:id" element={<ProtectedRoute><EditInvoice /></ProtectedRoute>} />
            <Route path="/payments" element={<ProtectedRoute><PaymentsScreen /></ProtectedRoute>} />
            <Route path="/payments/record" element={<ProtectedRoute><RecordPayment /></ProtectedRoute>} />
            <Route path="/payments/edit/:id" element={<ProtectedRoute><RecordPayment /></ProtectedRoute>} />
            <Route path="/expenses" element={<ProtectedRoute><ExpensesScreen /></ProtectedRoute>} />
            <Route path="/expenses/add" element={<ProtectedRoute><AddExpensesScreen /></ProtectedRoute>} />
            <Route path="/expenses/edit/:id" element={<ProtectedRoute><AddExpensesScreen /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><ReportScreen /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><UserRolesScreen /></ProtectedRoute>} />
            <Route path="/team-performance" element={<ProtectedRoute><TeamPerformanceScreen /></ProtectedRoute>} />
            <Route path="/marketing" element={<ProtectedRoute><MarketingScreen /></ProtectedRoute>} />
            <Route path="/vat" element={<ProtectedRoute><VATScreen /></ProtectedRoute>} />
            <Route path="/integrations" element={<ProtectedRoute><IntegrationsScreen /></ProtectedRoute>} />
            <Route path="/users/add" element={<ProtectedRoute><AddUser /></ProtectedRoute>} />
          </Routes>
        </MainLayout>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
